import { servicesKeys } from './useServices.ts'

/**
 * Query keys for sermon writing (docs/15, "Sermon writing"): a plan's ideas
 * under the plan (whatever refreshes a plan refreshes them), and the
 * church-level series outlines and sermon search under services.
 */
export const sermonKeys = {
  planIdeas: (planId: string) => [...servicesKeys.plan(planId), 'ideas'] as const,
  seriesPlans: () => [...servicesKeys.all(), 'series-plans'] as const,
  search: (filters: { q: string; theme: string; book: string }) =>
    [...servicesKeys.all(), 'sermon-search', filters] as const,
  themes: () => [...servicesKeys.all(), 'sermon-themes'] as const,
}
